<template>
<div class="filed-layout">
  <div :class="{'wrap': true, 'column': column}">
    <div class="label" :class="{'require': required, 'disabled': disabled}">{{label}}</div>
    <div class="content" :class="{'disabled': disabled}">
      <slot></slot>
    </div>
  </div>
  <van-divider style="margin: 0;" />
</div>
</template>

<script>
export default {
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    column: {
      type: Boolean,
      default: false,      
    }
  },
}
</script>

<style lang="less">
.filed-layout {
  padding: 10px 16px 0px 16px;
  .wrap {
    display: flex;
    text-align: left;
    padding-bottom: 10px;
    .label {
      box-sizing: border-box;
      width: 6.2em;
      margin-right: 12px;
      color: #646566;
      text-align: left;
      word-wrap: break-word;
    }
    .label.disabled {
      color: #c8c9cc;
    }
    .content {
      flex: 1;
    }
    .content.disabled {
      color: #c8c9cc;
    }
  }
  .column>.content {
    padding-top: 10px;
  };
}
.column {
  flex-direction: column;
}
.require::before {
  position: absolute;
  left: 8px;
  color: #ee0a24;
  
  content: '*';
}
.disabled {
  color: #c8c9cc;
}
</style>